import { WhmGridColDef } from "@securitize/reactjs-whm";
import {
  FieldSchemaType,
  FieldSchemaTypes,
  FundHoldingSchema,
} from "../../data/dtos/fund-holding-schema";
import { I18NContextType } from "../../contexts/I18nContext";
import { CurrencyFormat } from "@securitize/reactjs-sid-utils";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export const ROWS_PER_PAGE_OPTIONS = [25, 50];

const getWhmColumnType = (type: FieldSchemaType): WhmGridColDef["type"] => {
  if (
    (
      [
        FieldSchemaTypes.currency,
        FieldSchemaTypes.percentage,
        FieldSchemaTypes.date,
      ] as FieldSchemaType[]
    ).includes(type)
  ) {
    return "string";
  }

  return type as WhmGridColDef["type"];
};

export const buildColumns = (
  columnsSchema: FundHoldingSchema,
  getTranslation: I18NContextType["getTranslation"],
): WhmGridColDef[] => {
  return columnsSchema.map((field) => ({
    field: field.field,
    headerName: getTranslation(field.titleKey),
    type: getWhmColumnType(field.type),
    flex: field.flex ?? 1,
    align: field.align ?? "left",
    headerAlign: field.align ?? "left",
    resizable: false,
    sortable: false,
    disableColumnMenu: true,
  }));
};

const currencyFormatter = new CurrencyFormat({
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const valueFormatter = (
  value: string,
  type: FieldSchemaType,
): string | Date => {
  // Return "N/A" if value is undefined, null, or empty string
  if (value === undefined || value === null || value === "") {
    return "N/A";
  }

  switch (type) {
    case FieldSchemaTypes.percentage:
      return `${value} %`;

    case FieldSchemaTypes.currency:
      return currencyFormatter.format(Number(value));

    case FieldSchemaTypes.date:
      return dayjs(value).utc().format("DD MMM YYYY");

    case FieldSchemaTypes.number:
      return currencyFormatter.formatNumber(Number(value));

    default:
      return value;
  }
};
